import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@nrwl/common-lib';
@Injectable({
  providedIn: 'root'
})
export class DmzSystemSettingService {
  getDmzWebAccessConfigPath = '/uicomm/getServerConfig';
  saveDmzWebAccessConfigPath = '/uicomm/saveServerConfig';
  constructor(private readonly apiService: ApiService) {}
  //eslint-disable-next-line
  getWebServerConfig(): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.getDmzWebAccessConfigPath}`, {});
  }
  //eslint-disable-next-line
  updateDmzWebConfig(data): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.saveDmzWebAccessConfigPath}`, data);
  }
}
